import { Fragment } from 'react';
import Layout from './components/layout/Layout';

function App() {
  return (
    <Fragment>
      <Layout />
    </Fragment>
  );
}

export default App;
